import { createContext, PropsWithChildren, useContext, useState } from 'react';
import * as React from 'react';

export interface ISearchVisibilityContext {
  show: boolean;
  toggleShow: () => void;
}

export const SearchVisibilityContext = createContext<ISearchVisibilityContext>(null!);

const SearchVisibilityContextProvider: React.FC<PropsWithChildren> = ({ children }) => {

  const [show, setShow] = useState<boolean>(false);

  const toggleShow = () => {
    setShow(() => !show);
  };

  return (
    <SearchVisibilityContext.Provider value={{ show, toggleShow }}>
      {children}
    </SearchVisibilityContext.Provider>
  );
};

const useSearch = () => {
  return useContext(SearchVisibilityContext);
};

export { SearchVisibilityContextProvider, useSearch };
